import SiteModal, { SiteFormValues } from '../../../components/location-management/SiteModal';
import { AccountStorageSite } from '../../../types/interfaces/accountStorage.interfaces';
import { createAccountStorageSite, updateAccountStorageSite } from '../../../api/accountStorageItemsApi';
import { useAppSelector } from '../../../redux/hooks';

type OnFarmSiteModalProps = {
  mode: 'add' | 'edit';
  close: () => void;
  site?: AccountStorageSite;
  setSelectedId?: (id: number) => void;
};

const OnFarmSiteModal = ({ mode, close, site, setSelectedId }: OnFarmSiteModalProps): JSX.Element => {
  const accountId = useAppSelector(state => state.activeAccount.accountId);
  const siteValues = site ? { name: site.name, active: site.active } : undefined;

  const createSite = async ({ name, active }: SiteFormValues) => {
    const { data: id } = await createAccountStorageSite({ name, active, accountId });
    return id;
  };

  const updateSite = async ({ name, active }: SiteFormValues) => {
    if (!site) {
      return;
    }
    await updateAccountStorageSite(site.accountStorageSiteId, { name, active });
  };

  return (
    <SiteModal
      mode={mode}
      close={close}
      site={siteValues}
      code={site?.siteCode}
      setSelectedId={setSelectedId}
      createSite={createSite}
      updateSite={updateSite}
    />
  );
};

export default OnFarmSiteModal;
